export const COMMUNITY_AGGREGATOR_FIELDS = {
  GOOGLE: 'google_map_location',
  APFM: 'a_place_for_mom_id',
  CARING: 'caring_url',
};

export const COMMUNITY_INFO_MODE = {
  SYSTEM: 1,
  PRIVATE: 2,
};

export enum CommunityContactTypeEnum {
  COMMUNITY_REPRESENTATIVE = 1,
  MARKETING_AUTOMATION = 2,
}

export const COMMUNITY_CONTACT_TYPE_LABELS: Record<number, string> = {
  [CommunityContactTypeEnum.COMMUNITY_REPRESENTATIVE]: 'Community Representative',
  [CommunityContactTypeEnum.MARKETING_AUTOMATION]: 'Marketing Automation',
};

export enum CommunityContactDeliveryMethodEnum {
  DIRECT_EMAIL = 1,
  MARKETING_PLATFORM = 2,
}

export const COMMUNITY_CONTACT_DELIVERY_METHOD_LABELS: Record<number, string> = {
  [CommunityContactDeliveryMethodEnum.DIRECT_EMAIL]: 'Direct Email',
  [CommunityContactDeliveryMethodEnum.MARKETING_PLATFORM]: 'Marketing Platform',
};

export enum CommunityContactSourceEnum {
  MANUALLY_ADDED = 1,
  IMPORTED_FROM_PDF = 2,
  DETECTED_FROM_EMAIL = 3,
}

export const COMMUNITY_CONTACT_SOURCE_LABELS: Record<number, string> = {
  [CommunityContactSourceEnum.MANUALLY_ADDED]: 'Manually Added',
  [CommunityContactSourceEnum.IMPORTED_FROM_PDF]: 'Imported from PDF',
  [CommunityContactSourceEnum.DETECTED_FROM_EMAIL]: 'Detected from Email',
};
